import actions from "./actions"

const initialState = {
    vehicleSpeed: [],
    vehicleRpm: [],
    driverSpeed: [],
    driverRpm: [],
    driverStats: [],
    ignitionOnSpeed: [],
    ignitionOnRpm: []
};

export default function exceedingReducers(state = initialState, action: {payload: any, type:string}):any{
    switch (action.type){
        case actions.SET_EXCEEDING_SPEED_BY_VEHICLE_ID:
            return {...state, vehicleSpeed: action.payload};
        case actions.SET_EXCEEDING_RPM_BY_VEHICLE_ID:
            return {...state, vehicleRpm: action.payload};
        case actions.SET_EXCEEDING_RPM_BY_DRIVER_ID:
            return {...state, driverRpm: action.payload};
        case actions.SET_EXCEEDING_SPEED_BY_DRIVER_ID:
            return {...state, driverSpeed: action.payload};
        case actions.SET_DRIVER_STATS:
            return {...state, driverStats: action.payload};
        case actions.SET_IGNITION_ON_SPEED_BY_VEHICLE_ID:
            return {...state, ignitionOnSpeed: action.payload};
        case actions.SET_IGNITION_ON_RPM_BY_VEHICLE_ID:
            return {...state, ignitionOnRpm: action.payload};
        default:
            return state
    }
}